export class Style {
  public static TOOL_TIP_TEXT: string = 'text-align: left; margin-bottom: 0.1rem';

  public static TOOL_TIP_CSS_CLASS: string =
    ".tippy-box[data-theme~='intact'] {text-align: left;} " +
    ".tippy-box[data-theme~='intact']>.tippy-arrow:before {border-bottom-color: rgb(47 47 47 / 95%)}";
}
